import localSettings from "@app/config/LocalSettings";
import Path from "@app/enum/Path";
import isRestorableLocation from "@app/util/isRestorableLocation";

class AuthService {
  // some methods here don't do anything specific compared to localSettings' methods, so just borrow them

  getToken = localSettings.getAuthToken;
  setToken = localSettings.setAuthToken;
  hasToken = localSettings.hasAuthToken;
  resetToken = localSettings.resetAuthToken;
  resetAuthRefreshToken = localSettings.resetAuthRefreshToken;

  // wasSkeletonKeyUsed = localSettings.wasSkeletonKeyUsed;
  // setSkeletonKeyUsed = localSettings.setSkeletonKeyUsed;

  resetSession = () => {
    this.resetToken();
    this.resetAuthRefreshToken();
    localSettings.setSkeletonKeyUsed(false);
    localSettings.setLocationReminderAllowed(true);
    localSettings.setRecapChartRange();
    localSettings.resetDontShowDeleteEntityConfirmation();
    localSettings.resetActivityCreationNotifyPreferences();
    localSettings.removeAnonymousFlag();
    localSettings.setGlobalSearchQuery("");
    localSettings.setRecordLimitAlertHidden(false);
    localSettings.resetFilterBarDividerStatus();
  };

  saveLocation = (location: string) => {
    if (!isRestorableLocation(location)) {
      // Keep whatever is already stored. A stale 401 can ask for login while the user is
      // already on /login, and clearing here would destroy a target saved a moment earlier.
      return;
    }

    try {
      localSettings.setLocation(location);
    } catch {
      // Safari private mode throws on sessionStorage writes. Losing the redirect target is
      // acceptable; letting the throw escape would abort onLogin before it sends the user to
      // the login form, leaving them with no page at all.
    }
  };
  getSavedLocation = localSettings.getLocation;
  resetSavedLocation = localSettings.resetLocation;

  signOut = (location?: string) => {
    window.location.href = location ?? `${window.location.origin}${Path.ROOT}`;
  };
}

const authService = new AuthService();
export default authService;
